import { 
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  createUserWithEmailAndPassword
} from 'firebase/auth';
import { auth, db } from './config';
import { doc, getDoc, setDoc } from 'firebase/firestore';

// تسجيل الدخول
export const login = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    
    // الحصول على معلومات المستخدم من Firestore
    const userDoc = await getDoc(doc(db, 'users', user.uid));
    
    if (userDoc.exists()) {
      return {
        ...user,
        role: userDoc.data().role,
        displayName: userDoc.data().displayName
      };
    }
    
    return user;
  } catch (error) {
    console.error('Error logging in:', error);
    throw error;
  }
};

// تسجيل الخروج
export const logout = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    console.error('Error logging out:', error);
    throw error;
  }
};

// مراقبة حالة المصادقة
export const onAuthChange = (callback) => {
  return onAuthStateChanged(auth, callback);
};

// إنشاء مستخدم جديد (للاستخدام مرة واحدة فقط)
export const createAdmin = async (email, password) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    return userCredential.user;
  } catch (error) {
    console.error('Error creating admin:', error);
    throw error;
  }
};

// الحصول على المستخدم الحالي
export const getCurrentUser = () => {
  return auth.currentUser;
};

// الحصول على المستخدم الحالي مع الصلاحيات
export const getCurrentUserWithRole = async () => {
  try {
    const user = auth.currentUser;
    if (!user) return null;
    
    const userDoc = await getDoc(doc(db, 'users', user.uid));
    
    if (userDoc.exists()) {
      return {
        ...user,
        role: userDoc.data().role,
        displayName: userDoc.data().displayName,
        permissions: getUserPermissions(userDoc.data().role)
      };
    }
    
    return user;
  } catch (error) {
    console.error('Error getting current user with role:', error);
    return auth.currentUser;
  }
};

// الحصول على صلاحيات حسب الدور
const getUserPermissions = (role) => {
  const permissions = {
    admin: {
      canManageUsers: true,
      canManageImages: true,
      canManageCategories: true,
      canViewStats: true,
      canManageContact: true,
      canManageAbout: true,
      canViewMessages: true,
      canManageTopics: true
    },
    editor: {
      canManageUsers: false,
      canManageImages: true,
      canManageCategories: true,
      canViewStats: false,
      canManageContact: false,
      canManageAbout: false,
      canViewMessages: false,
      canManageTopics: true
    },
    viewer: {
      canManageUsers: false,
      canManageImages: true,
      canManageCategories: false,
      canViewStats: false,
      canManageContact: false,
      canManageAbout: false,
      canViewMessages: false,
      canManageTopics: false
    }
  };
  
  return permissions[role] || permissions.viewer;
};
